export const FOUR_K_MEDIA_QUERY = '(min-width: 3840px), (min-height: 3840px)';

export function is4kViewport() {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
		return false;
	}
	return window.matchMedia(FOUR_K_MEDIA_QUERY).matches;
}

export function mapCssScale() {
	return is4kViewport() ? 2 : 1;
}

let googleMapsLoadPromise = null;

export function loadGoogleMapsScript(apiKey) {
	if (!apiKey) {
		return Promise.reject(new Error('GOOGLE_MAPS_API_KEY is not set'));
	}
	if (googleMapsLoadPromise) {
		return googleMapsLoadPromise;
	}
	if (window.google && window.google.maps) {
		googleMapsLoadPromise = Promise.resolve();
		return googleMapsLoadPromise;
	}
	googleMapsLoadPromise = new Promise((resolve, reject) => {
		window.gm_authFailure = () => {
			googleMapsLoadPromise = null;
			reject(new Error(
				'Google Maps auth failed. Ensure: (1) Maps JavaScript API is enabled in GCP, ' +
				'(2) API restrictions on the key include "Maps JavaScript API" or "Don\'t restrict key", ' +
				'(3) Billing is enabled on the GCP project.'
			));
		};

		const script = document.createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=marker`;
		script.async = true;
		script.defer = true;
		script.onload = resolve;
		script.onerror = () => {
			googleMapsLoadPromise = null;
			reject(new Error('Failed to load Google Maps script'));
		};
		document.head.appendChild(script);
	});
	return googleMapsLoadPromise;
}
